import React, { useState } from 'react';
import SecondaryMenu from '../shared/SecondaryMenu';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import SvgIcon from '@material-ui/core/SvgIcon';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/Info';
import { TextField, FormHelperText } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import '../../style/UserStyleSheet.css';
import api from '../../store/api';
import DeletePopUp from "../shared/DeletePopUp";

interface AddEditClusterWidgetProps {
    id: string | null
};

//#region styles
const useStyles = makeStyles((theme) => ({
    root: {
        padding: 40,
        flexGrow: 1,
    },
    mainTop: {
        //padding: theme.spacing(5, 20, 0, 50)
        //paddingTop: 40,
        //paddingLeft: 40,
    },
    main: {
        //    padding: theme.spacing(0, 20, 0, 50)
        //paddingLeft: 40,
    },
    heading: {
        fontSize: 36,
        fontWeight: 900,
        padding: theme.spacing(0, 0, 2, 0)
    },
    textFieldLable: {
        fontSize: 15,
        color: '#949494',
        padding: theme.spacing(0, 0, 1, 0)
    },
    textFieldRoot: {
        width: '100%'
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '40px'
    },
    alertRoot: {
        marginTop: 24
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    formBtn: {
        margin: theme.spacing(0, 1, 0, 1),
        width: '100px',
        height: '40px'
    },
    formLeft: {
        //   margin: theme.spacing(0, 0, 0, 50)
        paddingLeft: 40,
        paddingBottom: 40,
        paddingTop: 20,

    },
    mainGrid: {
        width: '100%',
        //   padding: theme.spacing(1, 20, 0, 50)
        //paddingLeft: 40,
    },
    removeHover: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    deleteBtn: {
        float: 'right',
    },
}));

const ArrowIcon = (props: any) => {
    return (
        <SvgIcon style={{ height: 20, width: 20 }}>
            <path d="M6.293,13.707l-6-6L.257,7.67h0L.242,7.652.235,7.644.226,7.634.217,7.622.212,7.615.2,7.6l0,0L.186,7.581l0,0L.172,7.56l0,0L.158,7.54l0,0L.146,7.52l0,0L.134,7.5l0-.005L.122,7.48l0-.008L.112,7.46.106,7.449l0-.009L.094,7.424l0,0L.083,7.4h0a1,1,0,0,1,0-.8v0l.008-.017,0-.009L.1,6.562l.007-.014,0-.006a1,1,0,0,1,.182-.25l6-6A1,1,0,0,1,7.707,1.707L3.414,6H17a1,1,0,0,1,0,2H3.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z" fill="#02489D" />
        </SvgIcon>
    );
}

const StarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" style={{ marginRight: 5 }}>
            <path id="_copy" data-name="* copy" d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z" fill="#f4b827" />
        </svg>
    );
}

const CreateLoadingLine = (props: any): JSX.Element => {
    const classes = useStyles();
    return (
        <div className={classes.loading}>
            <LinearProgress color="primary" />
        </div>
    )
}

const HorizontalLine = (props: any) => {
    return (
        <hr
            style={{
                height: 0,
                borderTop: '1px solid #979797',
            }}
        />
    )
}
const AddEditClusterWidget: React.FC<AddEditClusterWidgetProps> = (props) => {
    const history = useHistory();
    const classes = useStyles();
    const id = props.id;
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    const [editItem, setEditItem] = useState(id ? true : false);
    const [editItemId, setEditItemId] = useState(id);
    const [headingText, setHeadingText] = useState('Clusters');
    const [mainHeadingText, setMainHeadingText] = useState(id ? 'Edit Cluster' : 'New Cluster');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [confirmationDialog, setConfirmationDialog] = useState(false);

    React.useEffect(() => {
        if (id) {
            setLoading(true);
            getEditItemData();
        } else {
            resetMessages();
        }

    }, []);

    const getEditItemData = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        try {
            const _res = await api.getEditLocationCluster('locationClusterId=' + editItemId);

            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setHeadingText(_res.data.model.name);
                let fields = ['name'];
                for (var field in fields) {
                    let fieldName = fields[field];
                    setValue(fieldName, _res.data.model[fieldName] ?? '');
                }
                setLoading(false);
                resetMessages();
            }
        }
        catch (error) {
            setErrorMessage('Error while editing transfer');
            setLoading(false);
        }
    }

    const addNewItem = async (): Promise<void> => {
        setLoading(true);
        setErrorMessage("");
        setStatusMessage("");
        let values = getValues();
        let _req: { [index: string]: any } = {
            name: values['name']
        }
        try {
            const requestResponse = await api.addLocationCluster('', _req);
            if (!requestResponse.hasError && requestResponse.message !== null) {
                setStatusMessage(requestResponse.message);
                backToList();
            }
            else {
                setErrorMessage(requestResponse.message ?? "");
            }
            setLoading(false);
        }
        catch (error) {
            setErrorMessage(error);
            setLoading(false);
        }
    }

    const updateItem = async (): Promise<void> => {
        setLoading(true);
        setErrorMessage("");
        setStatusMessage("");
        let values = getValues();
        let _req: { [index: string]: any } = {
            clusterId: editItemId,
            name: values['name']
        };

        try {
            const requestResponse = await api.updateLocationCluster('', _req)
            if (!requestResponse.hasError && requestResponse.message !== null)
                setStatusMessage(requestResponse.message);
            else {
                setErrorMessage(requestResponse.message);
            }
            setLoading(false);
        }
        catch (error) {
            setErrorMessage(error);
            setLoading(false);
        }
    }

    const deleteItem = async (): Promise<void> => {
        setLoading(true);
        setConfirmationDialog(false);
        setErrorMessage("");
        setStatusMessage("");
        let values = getValues();
        let _req: { [index: string]: any } = {
            clusterId: editItemId,
            name: values['name'],
            deleted: true
        };

        try {
            const requestResponse = await api.updateLocationCluster('', _req);
            if (!requestResponse.hasError && requestResponse.message !== null)
                backToList();
            else {
                setErrorMessage(requestResponse.message);
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            }
            setLoading(false);
        }
        catch (error) {
            setErrorMessage(error);
            setLoading(false);
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }
    }

    //#endregion

    const backToList = () => {
        history.push({
            pathname: '/settings/clusters'
        });
    };

    const resetMessages = () => {
        setErrorMessage('');
        setStatusMessage('');
    }
    //#endregion

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>
                <div style={{ alignSelf: 'stretch', display: 'flex', }}>
                    <SecondaryMenu selectedmenu='Clusters' />
                </div>
                <form style={{ width: '100%' }} onSubmit={handleSubmit(editItem ? updateItem : addNewItem)} autoComplete="off" id="itemForm">
                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 40 }}>
                            <Grid className={classes.mainGrid} container spacing={3}>
                                <Grid item xs={12}>
                                    <div className={classes.mainTop}>
                                        <IconButton className={classes.removeHover} onClick={backToList} aria-label="delete" size="small">
                                            <ArrowIcon /><span className="backBtn">{headingText}</span>
                                        </IconButton>
                                        {editItem ? <Button className={classes.deleteBtn} variant="contained" onClick={() => setConfirmationDialog(true)}>Delete</Button> : null}
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.main}>
                                        <div className={classes.heading}>
                                            {mainHeadingText}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4}>
                                    <div className={classes.textFieldLable}><StarIcon />NAME</div>
                                    <Controller
                                        control={control}
                                        as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                            error={errors.name}
                                            helperText={errors.name ? errors.name.message : ""} />}
                                        rules={{
                                            required: "Name is required",
                                        }}
                                        name='name'
                                        defaultValue=''
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div>
                            <div className={classes.main} style={{ paddingLeft: 40, paddingRight: 40 }}>
                                <div className={classes.headingAlert}>
                                    <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                        {errorMessage}
                                    </Alert>
                                    <Alert variant="filled" icon={<InfoIcon />} severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                                        {statusMessage}
                                    </Alert>
                                </div>
                            </div>

                            <div style={{ paddingTop: 20, paddingBottom: 20, }}>
                                {loading ? <CreateLoadingLine /> : <HorizontalLine />}
                            </div>

                            <div className={classes.formLeft}>
                                <Button disabled={formState.isSubmitting} className={classes.formBtn} variant="contained" color="primary" type='submit'>Save</Button>
                                <Button className={classes.formBtn} variant="contained" onClick={backToList}>Cancel</Button>
                            </div>

                        </div>
                    </div>

                </form>
            </div>
            <DeletePopUp 
                isDialogOpen={confirmationDialog} 
                onCancel={() => setConfirmationDialog(false)} 
                onDo={deleteItem} 
                title="Delete cluster"
                recordName="cluster" 
            />
        </>
    )
}
export default AddEditClusterWidget;